"use client";
import { useRouter } from "@/Components/AppProgressBar";
import { useT } from "@/Hooks";
import { usePathname, useSearchParams } from "next/navigation";
import { FormEvent, useState } from "react";
import { FiSearch } from "react-icons/fi";

const StickySidebarSearch = () => {
  const router = useRouter();
  const t = useT();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const [q, setQ] = useState(searchParams?.get("q") ?? "");

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();

    const sp = new URLSearchParams(searchParams?.toString());

    if (q) sp.set("q", q);
    else sp.delete("q");

    sp.set("page", "1");

    router.push(`${pathname}?${sp.toString()}`);
  };

  return (
    <div className="card search-widget">
      <div className="card-body">
        <form className="search-form" onSubmit={onSubmit}>
          <div className="input-group">
            <input
              type="text"
              placeholder={t("common.action.search", undefined, "Search")}
              className="form-control"
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
            <button type="submit" className="btn btn-primary">
              <FiSearch />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StickySidebarSearch;
